// src/UpgradeModal.jsx
import React from 'react';

function UpgradeModal({ onClose, matchesLimit = 5 }) {  // 🔧 Ajout de matchesLimit
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        maxWidth: '600px',
        width: '100%',
        padding: '40px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        position: 'relative'
      }}>
        {/* Bouton fermer */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666',
            padding: '4px 8px'
          }}
        >
          ✕
        </button>

        {/* Titre */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>🎾</div>
          <h2 style={{ 
            margin: '0 0 12px 0', 
            fontSize: '28px', 
            color: '#333',
            fontWeight: 'bold'
          }}>
            Limite de matchs atteinte !
          </h2>
          <p style={{ 
            margin: 0, 
            color: '#666', 
            fontSize: '16px',
            lineHeight: '1.6'
          }}>
            Vous avez créé vos <strong>{matchesLimit} matchs gratuits</strong>.
            <br />
            Passez à un abonnement pour continuer.
          </p>
        </div>

        {/* Plans */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '20px',
          marginBottom: '24px'
        }}>
          {/* Plan NORMAL */}
          <div style={{
            border: '2px solid #e0e0e0',
            borderRadius: '12px',
            padding: '24px',
            textAlign: 'center',
            transition: 'all 0.2s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#2196f3';
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(33, 150, 243, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#e0e0e0';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>🎾</div>
            <h3 style={{ 
              margin: '0 0 8px 0', 
              fontSize: '20px',
              color: '#333'
            }}>
              Normal
            </h3>
            <div style={{ 
              fontSize: '32px', 
              fontWeight: 'bold',
              color: '#2196f3',
              marginBottom: '8px'
            }}>
              xx€
              <span style={{ fontSize: '16px', color: '#666', fontWeight: 'normal' }}>/mois</span>
            </div>
            <ul style={{
              textAlign: 'left',
              padding: '0 0 0 20px',
              margin: '16px 0',
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.8'
            }}>
              <li>Matchs <strong>illimités</strong></li>
              <li>Statistiques complètes</li>
              <li>Partage en direct</li>
              <li>Export Excel</li>
            </ul>
            <button style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#2196f3',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}>
              Choisir Normal
            </button>
          </div>

          {/* Plan EXPERT */}
          <div style={{
            border: '2px solid #9c27b0',
            borderRadius: '12px',
            padding: '24px',
            textAlign: 'center',
            position: 'relative',
            background: 'linear-gradient(135deg, rgba(156, 39, 176, 0.05) 0%, rgba(156, 39, 176, 0.1) 100%)',
            transition: 'all 0.2s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(156, 39, 176, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            <div style={{
              position: 'absolute',
              top: '-12px',
              right: '12px',
              backgroundColor: '#9c27b0',
              color: 'white',
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: 'bold'
            }}>
              POPULAIRE
            </div>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>⭐</div>
            <h3 style={{ 
              margin: '0 0 8px 0', 
              fontSize: '20px',
              color: '#333'
            }}>
              Expert
            </h3>
            <div style={{ 
              fontSize: '32px', 
              fontWeight: 'bold',
              color: '#9c27b0',
              marginBottom: '8px'
            }}>
              yy€
              <span style={{ fontSize: '16px', color: '#666', fontWeight: 'normal' }}>/mois</span>
            </div>
            <ul style={{
              textAlign: 'left',
              padding: '0 0 0 20px',
              margin: '16px 0',
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.8'
            }}>
              <li><strong>Tout de Normal</strong></li>
              <li>Mode Expert 🎯</li>
              <li>Émotions par point</li>
              <li>Synchronisation cardio</li>
              <li>Comparaison matchs</li>
              <li>Import vidéos</li>
            </ul>
            <button style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#9c27b0',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}>
              Choisir Expert
            </button>
          </div>
        </div>

        {/* Message info */}
        <div style={{
          textAlign: 'center',
          padding: '16px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          fontSize: '14px',
          color: '#666'
        }}>
          💡 <strong>Essai gratuit de 7 jours</strong> pour tous les abonnements
          <br />
          Annulez à tout moment, sans engagement
        </div>
      </div>
    </div>
  );
}

export default UpgradeModal;